var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    portrait: _vm.sidebarStyle === 'portrait'
  },attrs:{"id":"scrub-wrapper"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:((
      _vm.allowRewind
      && _vm.bulbInitialized
    )),expression:"(\n      allowRewind\n      && bulbInitialized\n    )"}],staticClass:"thin",attrs:{"id":"video-scrub-bar","disabled":(
      !_vm.allowRewind
      || _vm.isLiveSession
    )}},_vm._l((_vm.filteredInteractionGroups),function(group,i){return _c('button',{key:group.start,staticClass:"interaction-dot pointer",style:(_vm.getInteractionDotStyle(group)),attrs:{"aria-label":'jump to interaction group ' + (i + 1),"disabled":(!_vm.allowRewind || _vm.isLiveSession)},on:{"click":function($event){return _vm.seek(group.start)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }